// src/redux/slices/library/book.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BookType } from "../../../types/Library";

const initialState: BookType = {
    title: "",
    idCategory: "",
    copies: 0
};

const bookSlice = createSlice({
    name: "book",
    initialState,
    reducers: {
        setBookData: (state, action: PayloadAction<BookType>) => ({
            ...state,
            ...action.payload,
        }),
        resetBookData: () => initialState,
    },
});

export const { setBookData, resetBookData } = bookSlice.actions;
export default bookSlice.reducer;
